class lookbookCarousel extends HTMLElement {
  constructor() {
    super();

    this.initialise();
  }

  initialise() {
    this.initCarousel();
  }

  initCarousel() {
    this.swiper = new Swiper(this.querySelector(".lookbookSwiper"), {
      slidesPerView: 1.3,
      spaceBetween: 10,
      breakpoints: {
        768: {
          slidesPerView: 2.3,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
  }
}

customElements.define("lookbook-carousel", lookbookCarousel);
